import { UseCaseInteractor } from '../use-case'
import { NotificationsRepository } from '../domain/notifications.repository'

export const setNotificationsUseCase: UseCaseInteractor<[NotificationsRepository], [string], void> =
  (notificationsRepository: NotificationsRepository) =>
  async (token: string): Promise<void> => {
    return notificationsRepository.setMessagingToken(token)
  }
